var Curriculog = Curriculog || {};
Curriculog.ProposalForm = Curriculog.ProposalForm || {};

Curriculog.ProposalForm.Section = (function ($, _, Backbone, Section) {

	Section = Curriculog.CurriculogView.extend({
		el: function() {
			return $('.section');
		},

		events: {
			'click .section-heading': 'toggle'
		},

		/**
		 * Section initialization
		 *
		 * @param {object}     options           - init options
		 * @param {Element}    options.section   - DOM element
		 * @param {Model}      options.proposal  - proposal model
		 * @param {View}       options.formView  - proposal view
		 * @param {object}     options.userPermissions - various user permissions
		 * @param {collection} options.curricula - Curriculum collection
		 */
		initialize: function (options) {
			this.sectionObj = options.section;
			this.proposal = options.proposal;
			this.userPermissions = options.userPermissions;
			this.curricula = options.curricula;
			this.formView = options.formView;

			this.model = {
				id: $(this.sectionObj).data('id')
			};

			this.itemViews = [];
		},

		/**
		 * Creates and renders each field
		 *
		 * @return {promise}
		 */
		render: function () {
			var deferred = $.Deferred(),
				promises = [];

			this.setElement($('#section-' + this.model.id));

			// Init fields
			promises = this.renderFields();
			return $.when.apply($, promises).promise();
		},

		/**
		 * Renders each field sequentially
		 *
		 * @return {Array} - list of promises
		 */
		renderFields: function () {
			var fields = this.$el.find('.section-fieldset'),
				promises = [];

			if (fields.length > 0) {
				promises = _.map(fields, this.renderField, this);
			}
			return promises;
		},

		/**
		 * Renders an individual field based on type
		 *
		 * @param {Element} field
		 * @returns {Promise} - resolves when the field is rendered
		 */
		renderField: function(field) {
			field = $(field);
			var fieldType = field.data('type'),
				fieldId = field.data('id'),
				fieldView = null,
				fieldData = field.data(),
				fieldTypeViews = {
					text: Curriculog.ProposalForm.TextField,
					textarea: Curriculog.ProposalForm.TextAreaField,
					richtext: Curriculog.ProposalForm.RichTextField,
					checkbox: Curriculog.ProposalForm.CheckboxField,
					radio: Curriculog.ProposalForm.RadioField,
					smartfield: Curriculog.ProposalForm.SmartfieldField
					// curriculum: Curriculog.ProposalForm.CurriculumField,
					// assessment: Curriculog.ProposalForm.AssessmentField
				};

			if (!(fieldType in fieldTypeViews)) {
				return $.when(); // resolved promise
			}

			this.proposal.fields.add(fieldData);

			fieldView = new fieldTypeViews[fieldType]({
				el: field,
				section: this.model,
				proposal: this.proposal,
				userPermissions: this.userPermissions,
				curricula: this.curricula,
				formView: this.formView,
				collection: this.proposal.fields,
				model: this.proposal.fields.get(fieldId)
			});
			this.itemViews.push(fieldView);
			return fieldView.render();
		},

		/**
		 * Destroys all subviews
		 *
		 * @returns {Promise}
		 */
		destroy: function() {
			var promises = _.invoke(this.itemViews, 'remove');
			return $.when.apply($, promises);
		},

		/**
		 * Hooks into the backbone remove native to destroy subviews.
		 */
		remove: function() {
			this.destroy();
			return Curriculog.CurriculogView.prototype.remove.apply(this, arguments);
		},

		/**
		 * Shows/Hides the section contents
		 *
		 * @param {Event} event
		 */
		toggle: function(event) {
			var $section = $(event.currentTarget);
			if ($section.find('.scroller').hasClass('open')) {
				$section.find('.scroller').removeClass('open').addClass('closed');

			} else {
				$section.find('.scroller').addClass('open').removeClass('closed');
			}

			function stretch() {
				Backbone.trigger('form:stretch');
			}

			$section.siblings('ul.section-fields').fadeToggle({
				duration: 'fast',
				start: stretch,
				always: stretch
			});
		}

	});

	return Section;

})($, _, Backbone, Curriculog.ProposalForm.Section || {});